module.exports = __webpack_public_path__ + "img/ccessibility.26fc1720.png";